import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import 'ag-grid-enterprise';

import { MaterialCustomModule } from './material-custom.module';
import { AccountingModule } from './modules/accounting/accounting.module';
import { AppIntegrationAccountModule } from './modules/app-integration-account/app-integration-account.module';
import { ApprovalModule } from './modules/approval/approval.module';
import { AssemblyOrderModule } from './modules/assembly-order/assembly-order.module';
import { AutomationRuleModule } from './modules/automation-rule/automation-rule.module';
import { BomModule } from './modules/bom/bom.module';
import { ChannelModule } from './modules/channel/channel.module';
import { ClientModule } from './modules/client/client.module';
import { CreditMemoModule } from './modules/credit-memo/credit-memo.module';
import { CustomFieldModule } from './modules/custom-field/custom-field.module';
import { FilterModule } from './modules/filter/filter.module';
import { InvoiceModule } from './modules/invoice/invoice.module';
import { LocationModule } from './modules/location/location.module';
import { OrderModule } from './modules/order/order.module';
import { PackageModule } from './modules/package/package.module';
import { PaymentModule } from './modules/payment/payment.module';
import { PicklistModule } from './modules/picklist/picklist.module';
import { PurchaseOrderModule } from './modules/purchase-order/purchase-order.module';
import { ReceivingReportModule } from './modules/receiving-report/receiving-report.module';
import { ReportingModule } from './modules/reporting/reporting.module';
import { RfqModule } from './modules/rfq/rfq.module';
import { SalesOrderModule } from './modules/sales-order/sales-order.module';
import { DirectiveModule } from './modules/shared/directives/directive.module';
import { TokenInterceptor } from './modules/shared/intercetors/token.interceptor';
import { PipeModule } from './modules/shared/pipes/pipe.module';
import { SharedModule } from './modules/shared/shared.module';
import { ShippingModule } from './modules/shipping/shipping.module';
import { StockModule } from './modules/stock/stock.module';
import { SupplierModule } from './modules/supplier/supplier.module';
import { SystemSettingModule } from './modules/system-setting/system-setting.module';
import { TagModule } from './modules/tag/tag.module';
import { UiModule } from './modules/ui/ui.module';
import { SharedComponentsModule } from './shared-components.module';

const lumModules = [
  ClientModule,
  FilterModule,
  InvoiceModule,
  LocationModule,
  MaterialCustomModule,
  OrderModule,
  PicklistModule,
  RfqModule,
  SharedComponentsModule,
  SharedModule,
  ShippingModule,
  SystemSettingModule,
  UiModule,
  PurchaseOrderModule,
  CreditMemoModule,
  ChannelModule,
  TagModule,
  AppIntegrationAccountModule,
  CustomFieldModule,
  SalesOrderModule,
  AccountingModule,
  ReportingModule,
  BomModule,
  AssemblyOrderModule,
  ApprovalModule,
  SupplierModule,
  StockModule,
  PackageModule,
  PaymentModule,
  AutomationRuleModule,
  PipeModule,
  DirectiveModule,
  ReceivingReportModule,
];

@NgModule({
  declarations: [],
  exports: [...lumModules],
  imports: [CommonModule, ...lumModules],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
})
export class LuminousV2Module {}
